module.exports = __webpack_public_path__ + "assets/addc0a0555aefe20d8af9ab795333de2.png";